// extracted by mini-css-extract-plugin
module.exports =  {"deferVat":"deferVat_QYeVk4JS"};